<template>
  <div class="wy-evaluation-preview">
    <div class="preview-header">
      <div class="line-divider-1px"></div>
      <h2>{{ formData.name }} preview</h2>
    </div>
    
    <div class="preview-content">
      <!-- Form Details -->
      <!-- <div class="form-details">
        <h3 class="form-name">{{ formData.name || 'Untitled Form' }}</h3>
        <p class="form-description">{{ formData.description || 'No description provided' }}</p>
        
        <div class="form-meta">
          <div class="meta-item">
            <span class="label">Status:</span>
            <span class="value" :class="formData.status">{{ capitalizeFirstLetter(formData.status) }}</span>
          </div>
          <div class="meta-item">
            <span class="label">Weighting:</span>
            <span class="value">{{ formData.manualWeighting ? 'Manual' : 'Automatic' }}</span>
          </div>
        </div>
      </div> -->

      <!-- Sections -->
      <div class="sections">
        <div v-for="(section, sIndex) in formData.sections" 
             :key="'section-' + sIndex"
             class="section">
          <div class="section-header">
            <div><h4 class="section-name">{{ section.name }}</h4></div>
            <div><span class="section-weight">Worth {{ formatWeight(section.weight, sIndex) }}% of evaluation</span></div>
          </div>

          <!-- Questions -->
          <div class="questions">
            <div v-for="(question, qIndex) in section.questions" 
                 :key="'question-' + qIndex"
                 class="question">
              <div v-if="question.questionType && question.questionType === 'PHRASE_MATCH'" class="question-header">
                <span v-if="question.text && question.text.length > 0" class="question-category">
                  <!-- {{sIndex + 1}}.{{qIndex + 1}} Did {{getSentByContent(question.phraseMatchSentBy)}} say "{{ question.text }}"  -->
                  <span v-html="formatQuestionText(sIndex + 1 + '.' + (qIndex + 1) + ' ' + question.text)"></span>
                  <span class="question-weight">{{ formatWeight(question.weight, qIndex, section) }}%</span>
                </span>
              </div>
              <div v-else class="question-header">
                <span  v-if="question.text && question.text.length > 0" class="question-category">
                  <span v-html="formatQuestionText(sIndex + 1 + '.' + (qIndex + 1) + ' ' + question.text)"></span>
                  <span class="question-weight">{{ formatWeight(question.weight, qIndex, section) }}%</span>
                </span>
              </div>
              
              <div class="question-content">
                <!-- <p class="question-text">{{ question.text }}</p>
                <p v-if="question.description" class="question-description">
                  {{ question.description }}
                </p> -->
                <!-- Question Options -->
                <div v-if="question.text && question.text.length>0 && question.options && question.options.length" class="options">
                  <div v-for="option in sortedOptions(question.options)" 
                       :key="option.id"
                       class="option"
                       :class="{ 'default-option': option.isDefault }">
                      <button class="label-btn">
                        <span class="option-label">{{ option.label }}</span>
                        <span v-if="option.points!=-1" class="option-points">({{ option.points }}%)</span>
                      </button>
                  </div>
                </div>
                <!-- Metadata Question Threshold -->
                <!-- <div v-if="question.questionType === 'METADATA'" class="threshold-info">
                  <span class="threshold-label">{{ question.thresholdLabel }}:</span>
                  <span class="threshold-operator">
                    {{ question.thresholdOperator }}
                  </span>
                  <span class="threshold-value">
                   {{ formatThresholdValue(question) }}
                  </span>
                </div> -->
              </div>
            </div>
          </div>
          <div class="divider" :class="{'no-layout':sIndex==formData.sections.length-1}"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { formatToDecimalString } from '@/components/autoQA/utils/wy-math-utils.js';

export default {
  name: 'wy-evaluation-preview',
  
  props: {
    formData: {
      type: Object,
      required: true
    },
    categoryQuestions: {
      type: Array,
      required: true
    },
    metaDataFields: {
      type: Array,
      default: () => []
    }
  },

  methods: {

    getSentByContent(sentBy) {
      if(sentBy === 'customer') {
        return 'the customer ';
      }
      else if(sentBy === 'agent') {
        return 'the agent ';
      }
      else {
        return 'all';
      }
    },
    capitalizeFirstLetter(string) {
      if (!string) return '';
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    formatQuestionText(text) {
      if (!text) return '';
      // Replace patterns like <@XXX> with @displayName from metaDataFields in blue color
      return text.replace(/<@([^>]+)>/g, (match, p1) => {
        const metadataField = this.metaDataFields.find(field => field.key === p1);
        const replacement = metadataField && metadataField.displayName ? metadataField.displayName : p1;
        return `<span style="color: #1890FF;">@${replacement}</span>`;
      });
    },

    formatWeight(weight, index, section) {
      if(this.formData.manualWeighting) {
        return formatToDecimalString(weight, 2);
      }
      else {
        if(section) {
          return formatToDecimalString(this.balanceWeight(section.questions, index), 2);
        }
        else {
          return formatToDecimalString(this.formData.sections[index].weight, 2);
        }
      }
    },

    balanceWeight(data, index) {
      let returnWeight = 0;
      if(data.length === 3) {
        if(index === (data.length - 1)) {
          returnWeight = 34
        }
        else {
          returnWeight = 33
        }
      }
      else {
        returnWeight = 100 / data.length;
      }
      return returnWeight
    },

    formatThresholdValue(question) {
      if (question.questionKey === 'number_of_hold_events') {
        return question.thresholdValue;
      }
      // Convert milliseconds to seconds for display
      return (question.thresholdValue / 1000).toFixed(0) + ' seconds';
    },

    sortedOptions(options) {
      return [...options].sort((a, b) => a.order - b.order);
    },

    getCategoryName(questionKey) {
      for (const category of this.categoryQuestions) {
        const matchingQuestion = category.questions.find(q => q.questionKey === questionKey);
        if (matchingQuestion) {
          return category.categoryName;
        }
      }
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.wy-evaluation-preview {
  // width: 400px;
  // width: -webkit-fill-available;
  min-width: 400px;
  height: 100%;
  // border: 2px solid #333;
  // background: #2b2b2b;
  overflow-y: auto;
  text-align: left;

  .preview-header {
    // padding: 30px 20px 51px 20px;
    padding: 30px 20px 51px 20px;
    // margin-left: 20px;
    // border-bottom: 1px solid #333;
    position: sticky;
    background: #FFF;
    top: 0;
    z-index: 1;
    height: 19px;
    .line-divider-1px {
      height: 1px;
      background: #000;
      width: calc(100% - 20px);
      position: absolute;
      top: 100px;
    }
    h2 {
      margin: 0;
      color: #000;
      font-size: 20px;
      position: relative;
      top: 6px;
    }
  }

  .preview-content {
    padding: 20px 0px 20px 0px;

    .form-details {
      // background: #1e1e1e;
      padding: 20px;
      border-radius: 8px;
      margin-bottom: 20px;
      // border: 2px solid #333;

      .form-name {
        margin: 0 0 10px 0;
        color: #fff;
      }

      .form-description {
        color: #ccc;
        margin-bottom: 15px;
      }

      .form-meta {
        display: flex;
        gap: 15px;
        
        .meta-item {
          .label {
            font-weight: 500;
            color: #ccc;
          }

          .value {
            margin-left: 5px;
            &.editable { color: #66b1ff; }
            &.published { color: #67c23a; }
            &.archived { color: #f56c6c; }
          }
        }
      }
    }

    .section {
      // background: #1e1e1e;
      border-radius: 8px;
      margin-bottom: 20px;
      // border: 2px solid #333;

      .section-header {
        padding: 10px 20px 0px 20px;
        // background: #252525;
        border-radius: 8px 8px 0 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-items: flex-start;
        flex-direction: column;

        .section-name {
          margin: 0;
          color: #000;
          padding-bottom: 3px;
        }

        .section-weight {
          font-weight: 500;
          color: #9b9b9b;
          font-size: 0.875rem;
        }
      }

      .questions {
        padding: 20px;

        .question {
          // margin-bottom: 20px;
          padding-bottom: 20px;
          // border-bottom: 2px solid #333;

          &:last-child {
            margin-bottom: 0;
            padding-bottom: 0;
            border-bottom: none;
          }

          .question-header {
            display: flex;
            margin-bottom: 0px;
            justify-content: flex-start;

            .question-category {
              font-weight: 500;
              font-size: 0.875rem;
              color: #000;
            }

            .question-weight {
              margin-left: 10px;
              color: #9b9b9b;
              font-size: 0.875rem;
              line-height: 1.43;
            }
          }

          .question-content {
            .question-text {
              margin: 0 0 10px 0;
              color: #fff;
            }

            .question-description {
              color: #ccc;
              font-size: 0.9em;
              margin-bottom: 10px;
            }

            .threshold-info {
              // background: #252525;
              padding: 5px 10px 5px 15px;
              border-radius: 4px;
              margin-bottom: 0px;
              // border: 1px solid #333;

              .threshold-label {
                font-weight: 500;
                font-size: 0.9em;
                color: #000;
              }

              .threshold-operator {
                margin-left: 5px;
                font-size: 0.9em;
                color: #003B5C;
                font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                position: relative;
                top: -1px;
              }

              .threshold-value {
                font-size: 0.9em;
                color: #003B5C;
                font-family: "Roboto", "Helvetica", "Arial", sans-serif;
              }
            }

            .options {
              display: flex;
              justify-content: space-between;
              padding: 8px 12px 0px 12px;
              margin-bottom: 0px;
              // background: #252525;
              border-radius: 4px;
              // border: 1px solid #333;
              align-items: flex-start;
              flex-direction: row;
              justify-content: flex-start;
              flex-wrap: wrap;
              .option {
                display: flex;
                justify-content: space-between;
                padding: 8px 12px;
                margin-bottom: 5px;
                background: #FFF;
                border-radius: 4px;
                margin-right: 5px;
                border: 1px solid rgba(0, 59, 92, 0.5);

                // &.default-option {
                //   background: #2b3d4f;
                //   border: 1px solid #409eff;
                // }
                .label-btn {
                  background: transparent;
                  border: 0px;
                }

                .option-label {
                  color: #003B5C;
                  font-weight: 600;
                  font-size: 14px;
                  text-transform: uppercase;
                }

                .option-points {
                  padding-left: 5px;
                  color: #003B5C;
                  font-weight: 300;
                  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                }
              }
            }
          }
        }
      }
    }
    .divider {
      height: 16px;
      background-color: #eeeeee;
    }
    .divider.no-layout {
      height: 0px;
    }
  }
}
</style>